// Optional per-store tweaks, keyed by the iOrders store slug (profile.title).
// Stores are picked up automatically from the wingz-canada franchise group,
// so a new store needs NO entry here — it shows with its iOrders name.
//   name       — display name to use instead of the iOrders store name
//   comingSoon — while the store is closed in iOrders, show "Opening Soon"
//                instead of "Temporarily Closed" (no effect once it opens)
const storeOverrides = {
  "wingz-colonial-saskatoon-5272": { name: "Wingz 8 St E" },
  "wingz-rochdale": { name: "Wingz Rochdale Blvd" },
  "wingz-winnipeg-winnipeg-5170": { name: "Wingz Corydon Ave" },
  "wingz-strathmore-strathmore-5378": { name: "Wingz Archie Klaiber Trail" },
  "wingz-stans-place-saskatoon-5460": { name: "Wingz Ruth Street East" },
  "wingz-regina-5463": { name: "Wingz Albert St North" },
  "wingz-prince-albert-prince-albert-5475": { name: "Wingz 6 Ave E" },
  "wingz-morse-morse-5474": { name: "Wingz George Ave" },
  "wingz-terrace-terrace-5510": { name: "Wingz Greig Ave" },
  "wingz-burnaby-burnaby-5473": { name: "Wingz Kingsway" },
  "wingz-turner-valley-diamond-valley-5442": { name: "Wingz Sunset Blvd SW" },
  "wingz-4610-albert-st-regina-5621": { name: "Wingz Albert St South" },
  "wingz-nw-calgary-calgary-5476": { name: "Wingz 10 St NW" },
  "wingz-moose-jaw-moose-jaw-5871": { name: "Wingz Moose Jaw", comingSoon: true },
};

export default storeOverrides;
